export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-intro_EN.2a8db0bd.png";